import React, { type FC, type PropsWithChildren, type ReactNode } from "react";
import { LegalLinkFooter } from "./LegalLinkFooter";

interface LayoutProps extends PropsWithChildren {
  hideFooter?: boolean;
  justifyContent?: 'center' | 'start';
  /** Extra item rendered before the legal links in the footer. */
  footerStart?: ReactNode;
  /** Skip the legal links, keeping only `footerStart`. */
  hideFooterLinks?: boolean;
}

export const Layout: FC<LayoutProps> = ({
  children,
  hideFooter = false,
  justifyContent = 'center',
  footerStart,
  hideFooterLinks = false,
}) => {
  const justifyClass = justifyContent === 'start' ? 'justify-start' : 'justify-center'

  return (
    <div
      data-testid="layout"
      className={`relative flex h-dvh w-full flex-1 flex-col items-center ${justifyClass} xs:gap-24 overflow-auto bg-background-contrast dark:bg-background-default-dark`}
    >
      {children}
      {!hideFooter && (
        /* biome-ignore lint/a11y/useSemanticElements: the semantic role is useless but the audit company expects to see it  */
        <footer role="contentinfo" className="w-full p-8">
          <div className="mx-auto">
            <LegalLinkFooter leading={footerStart} hideLinks={hideFooterLinks} />
          </div>
        </footer>
      )}
    </div>
  );
};
